import * as Sentry from "@sentry/react";
import type { User } from "firebase/auth";

const environment = import.meta.env.VITE_APP_ENV;

// Initialize Sentry only in production environment
if (environment === "prd") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    environment,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Use className 'sentry-mask' to mask sensitive elements in session replays
        maskAllText: false,
      }),
    ],
    // Session Replay
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });
}

// Helper function to set user context in Sentry
export function setSentryUser(user: User | null) {
  if (environment !== "prd") return;

  if (user) {
    Sentry.setUser({
      id: user.uid,
      email: user.email ?? undefined,
    });
  } else {
    Sentry.setUser(null);
  }
}

export { Sentry };
